/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DataVaxiomEmployerForm from 'DesignSystem/DataVaxiomEmployerForm/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/Employer/Options/Create/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 size="small"
 height="auto"
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 paddingTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Add Employer"
/>
</div>
</div>
<DataVaxiomEmployerForm
{...childProps}
  viewPath={`${viewPath}/DataVaxiomEmployerForm`}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}